'use client'

import dynamic from 'next/dynamic'
import { RawStoreData } from '@/lib/stores/store-types'

const LazyMap = dynamic(() => import('@/components/StoreMap'), {
	ssr: false,
	loading: () => <p>Loading...</p>,
})

export default function StoreDetailMap({
	store,
	dictionary,
	currentTime,
	locale,
}: {
	store: RawStoreData
	dictionary: Record<string, string>
	currentTime: Date
	locale: string
}) {
	return (
		<LazyMap
			locale={locale}
			stores={[store]}
			originalCenter={store.coordinates}
			zoom={15}
			storeToHighlight={store}
			dictionary={dictionary}
			currentTime={currentTime}
		/>
	)
}
